(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name fdpExceedanceReport.controller:FdpExceedanceReportCtrl
   *
   * @description
   *
   */
  angular
    .module('fdpExceedanceReport')
    .controller('FdpExceedanceReportCtrl', FdpExceedanceReportCtrl);

  function FdpExceedanceReportCtrl(CommonMasterData, $sce, CommonLogicService) {
    var vm = this;
    vm.ctrlName = 'FdpExceedanceReportCtrl';

    vm.model = {
      searchPanelToggle: true,
      searchCriteria: {
        fromDate: null,
        toDate: null,
        crewBase : null,
        crewType: null
      },
      masterList: {
        crewTypes: [],
        crewBaseList :[],
        fromTimeInvalid: false,
        toTimeInvalid: false
      },
    };

    vm.clickOnSearch = function () {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };


    vm.submitSearch = function (params) {
      searchFDPExceedanceReport(params);
    };

    function searchFDPExceedanceReport(param) {
      vm.model.initialSearchDone = true;
      if (isValidSearchParams(param)) {
        vm.model.searchCriteria = param;
        vm.model.searchPanelToggle = false;

        var rptDesign = "fdp_exceedance_report.rptdesign";
        var url = CommonLogicService.getReportUrl(rptDesign, getSearchParamMap(param));
        vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
      }
    }

    vm.loadCrewID = function () {
      vm.model.searchCriteria.crewId = vm.model.searchCriteria.crew.crewId;
    };

    function getSearchParamMap(param) {
      var searchParamMap = {};
      searchParamMap["fromDate"] = param.fromDate;
      searchParamMap["toDate"] = param.toDate;
      searchParamMap["crewBase"] = (!!param.crewBase && !!param.crewBase.airPortCode) ? param.crewBase.airPortCode:'';

      if (!!param.crewType && !!param.crewType.crewTypeCode) {
        searchParamMap["crewTypeCode"] = param.crewType.crewTypeCode;
      }
      searchParamMap["referrer"] = window.location.origin;;
      return searchParamMap;
    }

    function isValidSearchParams(params) {
      setDateValidationFlags();
      if ((!!vm.model.searchCriteria.fromDate && !vm.model.masterList.fromTimeInvalid) &&
        (!!vm.model.searchCriteria.toDate && !vm.model.masterList.toTimeInvalid) &&
        (!!vm.model.searchCriteria.crewType)) {
        return true;
      }
      return false;
    }

    function setDateValidationFlags() {
      //if from date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
        vm.model.masterList.fromTimeInvalid = true;
      } else {
        vm.model.masterList.fromTimeInvalid = false;
      }
      if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
        vm.model.masterList.toTimeInvalid = true;
      } else {
        vm.model.masterList.toTimeInvalid = false;
      }

    }

    function isDateFormatInvalid(date) {
      if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
        return true;
      }
      return false;
    }

    (function loadCrewTypes() {
      CommonMasterData.getCrewTypeList(
        function (crewTypes) {
          vm.model.masterList.crewTypes = crewTypes;
          // vm.model.masterList.msgRecipients = crewTypes;
        },
        function () {
          console.log('Crew type retrieval error');
        }
      );
      // base list
      CommonMasterData.getCrewBaseList(function(crewBases) {
        vm.model.masterList.crewBaseList = crewBases;
      }, function() {
        console.log('Crew Base List retrieval error');
      });
    })();
  }
}());
